export default "__VITE_ASSET__cR3fsE7g__"